<template>
    <div>マイページ</div>
</template>

<script>
export default {
    name: 'Profile'
}
</script>